import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';

// table component
import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { MdUpload, MdUploadFile } from 'react-icons/md';
import { Document, Page as Pages } from 'react-pdf';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

// import aadharBackDummy from './dummy/aadharBackDummy.png';
import aadharBackDummy from '../../dummy/aadharBackDummy.png';
import aadharFrontDummy from '../../dummy/aadharFrontDummy.jpg';
import panCardDummy from '../../dummy/panCardDummy.jpg';
import photoDummy from '../../dummy/photoDummy.jpg';
import useJourneySelector from '../../../../store/Slice/Journey/JourneySelector';

export default function AddJourney4({ handlePrev }) {
  const [previewSubmitState, setPreviewSubmitState] = useState(null);
  const [activeStepPreview, setActiveStepPreview] = useState(0);

  const { JourneyEdit } = useJourneySelector();

  useEffect(() => {
    if (JourneyEdit?.journeyModel) {
      let journeyReviewCombineData = [];

      // Clone safely to avoid accidental mutation
      const wizards = JourneyEdit.journeyModel.journeyWizards || [];
      journeyReviewCombineData = [...wizards];

      if (JourneyEdit.journeyModel.journeyReviewWizard) {
        journeyReviewCombineData.push(JourneyEdit.journeyModel.journeyReviewWizard);
      }

      if (journeyReviewCombineData.length > 0) {
        setPreviewSubmitState(journeyReviewCombineData);
      }
    }
  }, [JourneyEdit]);

  const finishJourney = (type) => {
    if (type === 'next') {
      setActiveStepPreview((activeStepPreview) => activeStepPreview + 1);
    } else {
      setActiveStepPreview((activeStepPreview) => activeStepPreview - 1);
    }
  };

  return (
    <Box>
      {previewSubmitState && (
        <Box>
          <Stepper
            connector=""
            activeStep={activeStepPreview}
            sx={{ marginBottom: '25px' }}
            className="stepWizardOuter"
          >
            {previewSubmitState?.map((wizItem) => (
              <Step key={wizItem?.wizardName} className="stepWizard">
                <StepLabel className="stepWizardLabel">{wizItem?.wizardName}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <PreviewComponent
            previewSubmitState={previewSubmitState}
            activeStepPreview={activeStepPreview}
            finishJourney={finishJourney}
            handlePrev={handlePrev}
          />
        </Box>
      )}
    </Box>
  );
}

function PreviewComponent({ previewSubmitState, activeStepPreview, finishJourney, handlePrev }) {
  const [pageNumber, setPageNumber] = useState(1); // for react-pdf
  const [docPrevFlag, setDocPrevFlag] = useState({
    flag: false,
    srcPath: null,
    imgaltTag: null,
    contentType: null
  });

  function onDocumentLoadSuccess({ numPages }) {
    setPageNumber(1);
  }

  const uploadKycBackFile = () => {
    const browseField = document.getElementById('kycBackUploader');
    browseField.click();
  };

  const uploadKycFile = () => {
    const browseField = document.getElementById('kycUploader');
    browseField.click();
  };

  let isHeaderRendered = false;
  let documentBox = 0;
  const padTop = '0px';
  let borderBottomo = '';

  const docPrevHandler = (type, srcData) => {
    if (type === 'open') {
      const responseData = JSON.parse(srcData);
      setDocPrevFlag({
        flag: true,
        srcPath: responseData.src,
        imgaltTag: responseData.alt,
        contentType: responseData.contentType
      });
    } else {
      setDocPrevFlag({ flag: false, srcPath: null, imgaltTag: null, contentType: null });
    }
  };

  return (
    <Grid item xs="12" sm="6" mt={3}>
      {previewSubmitState[activeStepPreview].wizardCode !== 'REVIEW' ? (
        previewSubmitState[activeStepPreview]?.selectedCards.map((wizItem, wizItemIndex) => (
          <>
            <Grid item xs="12" sm="6" md="6" mt={2}>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                {wizItem?.cardCurrentTitle !== null && wizItem?.cardCurrentTitle.trim() !== ''
                  ? wizItem?.cardCurrentTitle
                  : wizItem?.masterCardModel?.cardName}
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={5}>
                <Grid container spacing={3}>
                  {wizItem?.selectedFields.map((selectedField, selectedFieldIndex) => {
                    if (
                      selectedField?.storedField?.documentMap !== null &&
                      selectedField?.storedField !== null
                    ) {
                      documentBox += 1;
                    }

                    if (wizItem?.selectedFields.length === selectedFieldIndex + 1) {
                      borderBottomo = '0px';
                    }

                    if (selectedFieldIndex >= 1) {
                      isHeaderRendered = true;
                    } else {
                      isHeaderRendered = false;
                    }
                    return wizItem.masterCardModel.cardType.typeCode === 'DOCUMENT' ? (
                      <Grid item xs={12} style={{ paddingTop: padTop }}>
                        <Box>
                          <TableContainer
                            component={Paper}
                            sx={{ borderRadius: '0.5rem 0.5rem 0 0', marginBottom: '0' }}
                          >
                            {!isHeaderRendered && (
                              <Typography variant="body2" marginBottom={2} marginTop={2}>
                                For faster processing of your application form, please scan and
                                upload a pdf/jpg file for the documents mentioned below. You will be
                                required to submit the original documents for verification by Real
                                Value Finloans.
                              </Typography>
                            )}

                            <Table aria-label="customized table" size="small" padding="normal">
                              {!isHeaderRendered && (
                                <TableHead className="tableHead">
                                  <TableRow>
                                    <TableCell style={{ width: '30%' }}>Documents</TableCell>
                                    <TableCell style={{ width: '15%' }}>Action</TableCell>
                                    <TableCell style={{ width: '15%' }}>
                                      Will Provide Later
                                    </TableCell>
                                    <TableCell style={{ width: '15%' }}>Unable to Submit</TableCell>
                                    <TableCell style={{ width: '20%' }}>Remarks</TableCell>
                                  </TableRow>
                                </TableHead>
                              )}

                              <TableBody>
                                <TableRow key={selectedFieldIndex}>
                                  <TableCell style={{ width: '30%', borderBottom: borderBottomo }}>
                                    {
                                      selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldName
                                    }
                                    <Typography variant="span" color="error">
                                      *
                                    </Typography>
                                  </TableCell>
                                  <TableCell style={{ width: '15%', borderBottom: borderBottomo }}>
                                    <IconButton
                                      aria-label="Example"
                                      className="docIcon"
                                      onClick={(e) => {
                                        const imgDetailsObj = {};
                                        imgDetailsObj.alt =
                                          selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                        imgDetailsObj.src = selectedField;
                                        imgDetailsObj.contentType = 'uploadPopUp';
                                        docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                      }}
                                    >
                                      <MdUploadFile />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell style={{ width: '15%', borderBottom: borderBottomo }}>
                                    <Checkbox size="small" />
                                  </TableCell>
                                  <TableCell style={{ width: '15%', borderBottom: borderBottomo }}>
                                    <Checkbox size="small" />
                                  </TableCell>
                                  <TableCell style={{ width: '20%', borderBottom: borderBottomo }}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      inputProps={{
                                        className: 'formControl formControlRemark'
                                      }}
                                      placeholder="Remarks"
                                      value=""
                                    />
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </Grid>
                    ) : (
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography
                            variant="body1"
                            className="FormLabel"
                            style={{ marginBottom: '5px' }}
                          >
                            {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}
                          </Typography>
                          {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'DROPDOWN' ? (
                            <Select
                              fullWidth
                              inputProps={{
                                className: `textInput customSelectBox dissabledMenu${selectedField?.storedField?.value}`
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              value={JSON.stringify(selectedField?.storedField?.value)}
                            >
                              <MenuItem value={JSON.stringify(selectedField?.storedField?.value)}>
                                {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                              </MenuItem>

                              {selectedField?.storedField?.options.map(
                                (optionsItem, optionsItemIndex) => (
                                  <MenuItem
                                    key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                    value={JSON.stringify(optionsItem)}
                                  >
                                    {optionsItem.defaultValueName}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'DATE' ? (
                            <TextField
                              type="date"
                              fullWidth
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              inputProps={{ className: 'textInput' }}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              value={selectedField?.storedField?.value}
                            />
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'NUMBER_FIELD' ? (
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              value={selectedField?.storedField?.value}
                            />
                          ) : (
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              value={selectedField?.storedField?.value}
                            />
                          )}
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Grid>

            {wizItem?.selectedFields.map((selectedField, selectedFieldIndex) => {
              if (selectedFieldIndex >= 1) {
                isHeaderRendered = true;
              } else {
                isHeaderRendered = false;
              }
              return wizItem?.masterCardModel?.cardType?.typeCode === 'DOCUMENT' ? (
                <Box mb={3}>
                  {!isHeaderRendered && (
                    <Box>
                      <Typography variant="body1" className="headingLineUp headingLineUpOut">
                        Uploaded {wizItem?.cardCurrentTitle}
                      </Typography>
                      <Box className="viewLeadCard cardTopMinusMargin">
                        <Box className="displayFlex flexWrap" style={{ marginTop: '-15px' }}>
                          {wizItem?.selectedFields.map(
                            (selectedFieldItem, selectedFieldItemIndex) => (
                              <>
                                <Box
                                  className="uploadFilePreview"
                                  mt={2}
                                  onClick={() => {
                                    const imgDetailsObj = {};
                                    imgDetailsObj.alt =
                                      selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                    if (
                                      selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'PHOTOGRAPH'
                                    ) {
                                      imgDetailsObj.src = photoDummy;
                                      imgDetailsObj.contentType = '';
                                    } else if (
                                      selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'AADHAR_CARD'
                                    ) {
                                      imgDetailsObj.src = aadharFrontDummy;
                                      imgDetailsObj.contentType = '';
                                    } else if (
                                      selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'PAN_CARD' ||
                                      selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'COMPANY_PAN_CARD'
                                    ) {
                                      imgDetailsObj.src = panCardDummy;
                                      imgDetailsObj.contentType = '';
                                    }

                                    docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                  }}
                                >
                                  <RemoveRedEyeIcon className="ImageViewIcon" />
                                  <Typography variant="body2" className="uploadFileText">
                                    {
                                      selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldName
                                    }
                                  </Typography>
                                </Box>
                                {selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster
                                  ?.fieldCode === 'AADHAR_CARD' ? (
                                  <Box
                                    className="uploadFilePreview"
                                    mt={2}
                                    onClick={() => {
                                      const imgDetailsObj = {};
                                      imgDetailsObj.alt =
                                        selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                      imgDetailsObj.src = aadharBackDummy;
                                      imgDetailsObj.contentType = '';
                                      docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                    }}
                                  >
                                    <RemoveRedEyeIcon className="ImageViewIcon" />
                                    <Typography variant="body2" className="uploadFileText">
                                      {`Back ${selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                                    </Typography>
                                  </Box>
                                ) : (
                                  ''
                                )}
                              </>
                            )
                          )}
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              ) : (
                ''
              );
            })}
          </>
        ))
      ) : (
        <Box>
          {previewSubmitState[activeStepPreview]?.reviewCards.map((wizItem) => (
            <Box>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                {wizItem.reviewCardHeading}
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {wizItem.selectedJourneyReviewCards.map((selectedJourneyReviewCardsItem) =>
                    selectedJourneyReviewCardsItem?.selectedJourneyCard?.masterCardModel?.cardType
                      ?.typeCode !== 'DOCUMENT'
                      ? selectedJourneyReviewCardsItem.reviewCardFields.map((reviewItem) => (
                          <Grid
                            item
                            xs={4}
                            key={`textOnly_${
                              reviewItem.reviewCardFieldHeading !== null
                                ? reviewItem?.reviewCardFieldHeading
                                : reviewItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                            }`}
                          >
                            <Box className="displayFlex">
                              <img
                                style={{
                                  width: '45px',
                                  marginRight: '15px',
                                  borderRadius: '5px'
                                }}
                                src={reviewItem.reviewCardFieldIcon}
                                alt=""
                              />
                              <Box>
                                <Typography variant="body2" className="labelText">
                                  {reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName}
                                </Typography>
                                <Typography variant="subtitle2" className="labelValue">
                                  {reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                    .fieldType.typeCode === 'DROPDOWN'
                                    ? 'Lorem ipsum'
                                    : 'Lorem ipsum'}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        ))
                      : selectedJourneyReviewCardsItem.reviewCardFields.map(
                          (reviewItem, reviewIndex) => (
                            <>
                              <Box
                                className="displayFlex flexWrap"
                                ml={reviewIndex === 0 ? 3 : ''}
                                mt={2}
                                key={`documentOnly_${
                                  reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName
                                }`}
                              >
                                <Box
                                  className="uploadFilePreview"
                                  onClick={() => {
                                    const imgDetailsObj = {};
                                    imgDetailsObj.alt =
                                      reviewItem.reviewCardFieldHeading !== null
                                        ? reviewItem?.reviewCardFieldHeading
                                        : reviewItem?.cardDetail?.cardFieldMapping
                                            ?.journeyCardFieldsMaster?.fieldName;
                                    if (
                                      reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                        .fieldCode === 'PHOTOGRAPH'
                                    ) {
                                      imgDetailsObj.src = photoDummy;
                                      imgDetailsObj.contentType = '';
                                    } else if (
                                      reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                        .fieldCode === 'AADHAR_CARD'
                                    ) {
                                      imgDetailsObj.src = aadharFrontDummy;
                                      imgDetailsObj.contentType = '';
                                    } else if (
                                      reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                        .fieldCode === 'PAN_CARD' ||
                                      reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                        .fieldCode === 'COMPANY_PAN_CARD'
                                    ) {
                                      imgDetailsObj.src = panCardDummy;
                                      imgDetailsObj.contentType = '';
                                    }
                                    docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                  }}
                                >
                                  {' '}
                                  <RemoveRedEyeIcon className="ImageViewIcon" />
                                  <Typography variant="body2" className="uploadFileText">
                                    {reviewItem.reviewCardFieldHeading !== null
                                      ? reviewItem?.reviewCardFieldHeading
                                      : reviewItem?.cardDetail?.cardFieldMapping
                                          ?.journeyCardFieldsMaster?.fieldName}
                                  </Typography>
                                </Box>
                              </Box>
                              {reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                .fieldCode === 'AADHAR_CARD' ? (
                                <Box
                                  className="displayFlex flexWrap"
                                  ml={reviewIndex === 0 ? 3 : ''}
                                  mt={2}
                                  key={`documentOnly_${
                                    reviewItem.reviewCardFieldHeading !== null
                                      ? reviewItem?.reviewCardFieldHeading
                                      : reviewItem?.cardDetail?.cardFieldMapping
                                          ?.journeyCardFieldsMaster?.fieldName
                                  }`}
                                >
                                  <Box
                                    className="uploadFilePreview"
                                    onClick={() => {
                                      const imgDetailsObj = {};
                                      imgDetailsObj.alt =
                                        reviewItem.reviewCardFieldHeading !== null
                                          ? reviewItem?.reviewCardFieldHeading
                                          : reviewItem?.cardDetail?.cardFieldMapping
                                              ?.journeyCardFieldsMaster?.fieldName;
                                      imgDetailsObj.src = aadharBackDummy;
                                      imgDetailsObj.contentType = '';
                                      docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                    }}
                                  >
                                    {' '}
                                    <RemoveRedEyeIcon className="ImageViewIcon" />
                                    <Typography variant="body2" className="uploadFileText">
                                      {`Back ${
                                        reviewItem.reviewCardFieldHeading !== null
                                          ? reviewItem?.reviewCardFieldHeading
                                          : reviewItem?.cardDetail?.cardFieldMapping
                                              ?.journeyCardFieldsMaster?.fieldName
                                      }`}
                                    </Typography>
                                  </Box>
                                </Box>
                              ) : (
                                ''
                              )}
                            </>
                          )
                        )
                  )}
                </Grid>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Dialog
        className="PopupBox"
        open={docPrevFlag.flag}
        onClose={() => docPrevHandler('close', '')}
        aria-describedby="alert-dialog-description"
      >
        {docPrevFlag.contentType !== 'uploadPopUp' ? (
          <DialogContent dividers className="PopupContent">
            <DialogContentText>
              {docPrevFlag.imgaltTag !== 'finish' ? (
                docPrevFlag.contentType === 'application/pdf' ? (
                  <Document
                    file={docPrevFlag.srcPath}
                    onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                  >
                    <Pages pageNumber={pageNumber} />
                  </Document>
                ) : (
                  <img
                    src={docPrevFlag.srcPath}
                    alt={docPrevFlag.imgaltTag}
                    style={{ margin: '0px auto' }}
                  />
                )
              ) : (
                <Typography
                  variant="h6"
                  className="popupTitle"
                  style={{ padding: '0px', justifyContent: 'center' }}
                >
                  {docPrevFlag.contentType}
                </Typography>
              )}
            </DialogContentText>
          </DialogContent>
        ) : (
          <>
            <DialogTitle
              id="alert-dialog-title"
              className="popupHeading"
              style={{ marginBottom: '0px', borderBottom: '1px solid #efefef' }}
            >
              <Typography variant="h6" className="popupTitle" style={{ paddingBottom: '0px' }}>
                Upload Document
              </Typography>
              <IconButton onClick={() => docPrevHandler('close', '')} size="small">
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers className="PopupContent">
              <DialogContentText id="alert-dialog-description">
                <FormControl sx={{ width: '100%' }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="Local File"
                    name="radio-buttons-group"
                  >
                    <Box
                      container
                      style={{
                        padding: '6px',
                        marginBottom: '9px',
                        border: '1px solid #efefef',
                        borderRadius: '5px'
                      }}
                    >
                      <Box className="uploadPopupInnerRow">
                        <FormControlLabel
                          value="Local File"
                          control={<Radio size="small" />}
                          label=""
                          sx={{ marginRight: '0.5rem' }}
                        />
                        <Typography variant="caption" className="UploadPopupIcon">
                          <MdUpload className="UploadIcon" />
                        </Typography>
                        <Typography variant="body1" marginRight={1} className="FileTypeName">
                          Local Files
                        </Typography>
                        <input id="kycUploader" className="Fileupload hideForView" type="file" />
                        <ShowInputBox val="" />
                        <Button type="button" onClick={uploadKycFile} className="uploadBtn">
                          Browse
                        </Button>
                      </Box>

                      {docPrevFlag.imgaltTag === 'Aadhar Card' ? (
                        <Box className="uploadPopupInnerRow">
                          <FormControlLabel
                            value="Local File"
                            control={<Radio size="small" />}
                            label=""
                            sx={{ marginRight: '0.5rem' }}
                          />
                          <Typography variant="caption" className="UploadPopupIcon">
                            <MdUpload className="UploadIcon" />
                          </Typography>
                          <Typography variant="body1" marginRight={1} className="FileTypeName">
                            Local Files
                          </Typography>
                          <input
                            id="kycBackUploader"
                            className="Fileupload hideForView"
                            type="file"
                          />
                          <TextField
                            value=""
                            inputProps={{ className: 'TextField' }}
                            className="TextFieldGroup"
                          />
                          <Button type="button" onClick={uploadKycBackFile} className="uploadBtn">
                            Browse
                          </Button>
                        </Box>
                      ) : (
                        ''
                      )}

                      <FormControl className="PassProtectB" defaultValue="No">
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          sx={{ marginRight: '0.5rem' }}
                        >
                          Is your file password protected?
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value=""
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" />}
                            label="No"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                    <Box
                      container
                      style={{
                        padding: '6px',
                        marginBottom: '9px',
                        border: '1px solid #efefef',
                        borderRadius: '5px'
                      }}
                    >
                      <Box className="uploadPopupInnerRow">
                        <FormControlLabel
                          value="Google Drive"
                          control={<Radio size="small" />}
                          label=""
                          sx={{ marginRight: '0.5rem' }}
                        />
                        <Typography variant="caption" className="UploadPopupIcon">
                          <img src="../static/icons/googleDrive.svg" alt="Google Drive" />
                        </Typography>
                        <Typography variant="body1" className="FileTypeName">
                          Google Drive
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      container
                      style={{
                        padding: '6px',
                        marginBottom: '9px',
                        border: '1px solid #efefef',
                        borderRadius: '5px'
                      }}
                    >
                      <Box className="uploadPopupInnerRow">
                        <FormControlLabel
                          value="Dropbox"
                          control={<Radio size="small" />}
                          label=""
                          sx={{ marginRight: '0.5rem' }}
                        />
                        <Typography variant="caption" className="UploadPopupIcon">
                          <img src="../static/icons/dropBox.svg" alt="Drop Box" />
                        </Typography>
                        <Typography variant="body1" className="FileTypeName">
                          Dropbox
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      container
                      style={{
                        padding: '6px',
                        marginBottom: '9px',
                        border: '1px solid #efefef',
                        borderRadius: '5px'
                      }}
                    >
                      <Box className="uploadPopupInnerRow">
                        <FormControlLabel
                          value="Digiloker"
                          control={<Radio size="small" />}
                          label=""
                          sx={{ marginRight: '0.5rem' }}
                        />
                        <Typography variant="caption" className="UploadPopupIcon">
                          <img src="../static/icons/digilocker.svg" alt="Digi Locker" />
                        </Typography>
                        <Typography variant="body1" className="FileTypeName">
                          DigiLocker
                        </Typography>
                      </Box>
                    </Box>
                  </RadioGroup>
                </FormControl>
                <Typography>
                  Note: The file types supported format type is PDF, JPEG & PNG. The maximum
                  uploaded file size is 10MB.
                </Typography>
              </DialogContentText>
            </DialogContent>
          </>
        )}
        <DialogActions>
          <Button className="mainBtn" onClick={() => docPrevHandler('close', '')}>
            {docPrevFlag.imgaltTag !== 'finish' ? 'Close' : 'Ok'}
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ display: 'flex' }}>
        {activeStepPreview > 0 ? (
          <Button
            onClick={() => finishJourney('back')}
            startIcon={<HiOutlineArrowNarrowLeft />}
            className="mainBtn previousBtn"
          >
            Back
          </Button>
        ) : (
          <Button
            onClick={() => handlePrev()}
            startIcon={<HiOutlineArrowNarrowLeft />}
            className="mainBtn previousBtn"
          >
            Back to Journey Review
          </Button>
        )}

        {previewSubmitState.length - 1 === activeStepPreview ? (
          <Button
            onClick={() => {
              const imgDetailsObj = {};
              imgDetailsObj.alt = 'finish';
              imgDetailsObj.src = '';
              imgDetailsObj.contentType = 'Your Application is Successfully Submitted';
              docPrevHandler('open', JSON.stringify(imgDetailsObj));
            }}
            className="mainBtn"
            variant="contained nextBtn"
          >
            Finish
          </Button>
        ) : (
          <Button
            onClick={() => finishJourney('next')}
            className="mainBtn"
            endIcon={<HiOutlineArrowNarrowRight />}
            variant="contained nextBtn"
          >
            Next
          </Button>
        )}
      </Box>
    </Grid>
  );
}

function ShowInputBox({ val }) {
  useEffect(() => {}, [val]);
  return (
    <TextField value={val} inputProps={{ className: 'TextField' }} className="TextFieldGroup" />
  );
}
